import { applyMiddleware, createStore, } from 'redux';
import { composeWithDevTools, } from 'redux-devtools-extension';

import { rootReducer, } from './ducks';
import middlewares, { runSaga, sagaMiddleware, } from './middlewares';

const configureStore = {
    createStore: (initialState: any = {}) =>
        createStore(
            rootReducer,
            initialState,
            composeWithDevTools(
                applyMiddleware(
                    sagaMiddleware,
                    ...middlewares,
                )
            )
        ),
    runSaga,
};

export default configureStore;
